import React from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import Button from "shared/Button";
import { Edit } from "react-ikonate";
import PanelHeader from "../components/PanelHeader";
import PromotionsCatalog from "./PromotionsCatalog";
import PromotionEditor from "./PromotionEditor";
import styles from "./index.module.css";

// Archived promotions are hidden by default; users can opt in via the Status
// filter. Mirrors the Store catalog's default-status behavior.
const PROMOTIONS_INITIAL_FILTERS = {
  status: ["Published", "Scheduled", "In Review"],
  type: [],
};

export default function Promotions() {
  const history = useHistory();
  const { path, url } = useRouteMatch();

  const handleEdit = (promo) => {
    history.push(`${url}/${promo.id}/edit`);
  };

  const renderItemActions = React.useCallback(
    (promo) => (
      <div className={styles.actionRow}>
        <Button
          onClick={() => handleEdit(promo)}
          title={`Open "${promo.name}" (read-only preview).`}
          className={styles.editButton}
        >
          <Edit size={16} /> Edit
        </Button>
      </div>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className={styles.container}>
      <Switch>
        <Route path={`${path}/:promotionId/edit`}>
          <PromotionEditor />
        </Route>
        <Route path={path}>
          <>
            <PanelHeader title="WWG Store - Promotions" />
            <div className={styles.content}>
              <PromotionsCatalog
                searchPlaceholder="Search Promotions"
                initialFilters={PROMOTIONS_INITIAL_FILTERS}
                renderItemActions={renderItemActions}
                actionColWidth="140px"
                toolbarActions={
                  <Button
                    className={styles.addButton}
                    title="Adding new promotions isn't available yet."
                    disabled
                  >
                    Add New Promotion
                  </Button>
                }
              />
            </div>
          </>
        </Route>
      </Switch>
    </div>
  );
}
